<div
  class="card card-step"
  [ngClass]="{ 'is-selected': dataSourceControl.value === isfEntity.id, 'is-desktop': isDesktop }"
  (click)="areaClicked.emit()"
>
  <div class="card-header">
    <app-radio-button
      [control]="dataSourceControl"
      [id]="'dataSource-' + isfEntity.id"
      [label]="label"
      [value]="isfEntity.id"
      [classGroup]="'not-mb'"
      [tooltipData]="isDesktop ? undefined : tooltipData"
    ></app-radio-button>
  </div>
  <div class="card-body card-body-info" *ngIf="isShowCard">
    <card-step-body [isShowIdentifierBlock]="isShowIdentifierBlock" [isfEntity]="isfEntity"></card-step-body>
  </div>
  <div class="card-footer card-footer-info" *ngIf="code === enumEntityModelCode.IMPORTER && !isfEntity.id && !isDesktop">
    <button class="btn btn-link" (click)="editUP()">
      <i class="fa fa-pencil"></i>
      {{ "EDIT_COMPANY" | translate }}
    </button>
  </div>
</div>
